import { css } from '@emotion/react';

const rowStyle = css({
  display: 'grid',
  fontSize: 12,
  gap: '0 6px',
  gridTemplateColumns: '24px 1fr',
  lineHeight: 1.6,
  padding: '2px 0',
});

const indexStyle = css({
  fontWeight: 600,
});

type ExportReportDetailRowProps = Readonly<{
  index: number;
  text: string;
  url?: string;
}>;

export const ExportReportDetailRowComponent = ({ index, text, url }: ExportReportDetailRowProps) => (
  <div css={rowStyle}>
    <span css={indexStyle}>{index}.</span>
    <span>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      ) : text}
    </span>
  </div>
);
